import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function useArchiveReserveReason() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const archiveReserveReason = async (reason_id) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.put(
        `/reserve-reasons/switch-archive-status/${reason_id}`
      );
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (response.status === 200) {
        setIsSuccess(true);
        toast.success(
          response.data?.message ||
            'Catégorie de réserve mise à jour avec succès.'
        );
      } else {
        setIsSuccess(false);
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setIsSuccess(false);
      toast.error(error?.response.data?.message || error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setError('');
    setIsSuccess(false);
    setIsLoading(false);
  };

  return {
    error,
    isLoading,
    isSuccess,
    archiveReserveReason,
  };
}
